// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SideWidgetFaqTopics_wrapper"};